var React = require('react');

function Checkmark (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#EA650D","stroke":"#EA650D","d":"m7.64 20.199.416.416.343-.478L20.796 2.855a.25.25 0 1 1 .407.29v.001l-12.913 18a.248.248 0 0 1-.182.103h-.006l-.008.001h-.007a.248.248 0 0 1-.176-.072v-.001L2.822 16.09a.25.25 0 1 1 .354-.353l4.462 4.462Z"}));
}

Checkmark.defaultProps = {"viewBox":"0 0 24 24","fill":"none"};

module.exports = Checkmark;

Checkmark.default = Checkmark;
